import { NgModule } from '@angular/core';
import { AssetPageRoutingModule } from './asset-page-routing.module';
import { AssetPageComponent } from './asset-page.component';
import {
    BriefComponent,
    NavMainLayoutComponent,
    PageBaseComponent,
    PageMastComponent,
    PageSectionComponent,
} from '@exl-ng/mulo-views';
import {
    DictionaryComponent,
    DictionaryItemComponent,
    DictionaryItemContentDirective,
    DictionaryItemLabelDirective,
    ExpandableComponent,
    FileActionDirective,
    FileListActionDirective,
    FileListComponent,
    FileListItemComponent,
    FileListItemInfoDirective,
    HorizontallerComponent,
    HorizontallerHeaderDirective,
    HorizontallerItemComponent,
    HtmlEscapePipe,
    HtmlStripPipe,
    InfobarComponent,
    KeywordItemComponent,
    KeywordsComponent,
    LoadingSlateComponent,
    SdgIconListComponent,
    SeparatorComponent,
    StatusTagComponent,
} from '@exl-ng/mulo-common';
import {
    HideOnPrintDirective,
    KeepOnPrintDirective,
    ShowOnlyOnPrintDirective,
    SvgViewboxDirective,
} from '@exl-ng/mulo-core';
import { SharedModule } from '../shared/shared.module';
import { ContentLoaderModule } from '@ngneat/content-loader';
import { CitationsModule } from '../parts/citations/citations.module';
import { UsageMetricsComponent } from './asset-page-sections/usage-metrics/usage-metrics.component';
import { DescriptionAndKeywordsComponent } from './asset-page-sections/description-and-keywords/description-and-keywords.component';
import { DetailsComponent } from './asset-page-sections/details/details.component';
import { RelatedContentComponent } from './asset-page-sections/related-content/related-content.component';
import { AssetPageMetadataEssentialsComponent } from './asset-page-essentials/asset-page-metadata-essentials/asset-page-metadata-essentials.component';
import { AuthorsEssentialsComponent } from './asset-page-essentials/authors-essentials/authors-essentials.component';
import { AssetFilesAndLinksComponent } from './asset-page-sections/files-and-links/asset-files-and-links.component';
import { AssetPageArcviewStandaloneComponent } from './asset-page-arcview-standalone/asset-page-arcview-standalone.component';
import { ArcviewModule } from '../parts/arcview/arcview.module';
import { CollectionsEssentialsComponent } from './asset-page-essentials/collections-essentials/collections-essentials.component';
import { IncitesHighlightsComponent } from './asset-page-sections/incites-highlights/incites-highlights.component';
import { NgForOf } from '@angular/common';
import { MultiLanguageModule } from '../parts/multi-language/multi-language.module';
import { PlainTextInputModule } from '../parts/plain-text-input/plain-text-input.module';
import { DepositTypeComponent } from '../deposit/deposit-sections/deposit-type/deposit-type.component';
import { DepositDoiComponent } from '../deposit/deposit-sections/deposit-doi/deposit-doi.component';
import { MatIcon } from '@angular/material/icon';
import { EntityLocalFieldsModule } from '../parts/entities/entity-local-fields/entity-local-fields.module';

@NgModule({
    imports: [
        SharedModule,
        AssetPageRoutingModule,
        PageBaseComponent,
        PageSectionComponent,
        PageMastComponent,
        FileListComponent,
        FileListItemComponent,
        FileListItemInfoDirective,
        FileActionDirective,
        FileListActionDirective,
        KeywordsComponent,
        KeywordItemComponent,
        ExpandableComponent,
        ContentLoaderModule,
        HorizontallerComponent,
        HorizontallerHeaderDirective,
        HorizontallerItemComponent,
        CitationsModule,
        SvgViewboxDirective,
        DictionaryComponent,
        DictionaryItemComponent,
        DictionaryItemLabelDirective,
        DictionaryItemContentDirective,
        HideOnPrintDirective,
        ShowOnlyOnPrintDirective,
        KeepOnPrintDirective,
        InfobarComponent,
        LoadingSlateComponent,
        SeparatorComponent,
        StatusTagComponent,
        AssetFilesAndLinksComponent,
        HtmlStripPipe,
        HtmlEscapePipe,
        ArcviewModule,
        NavMainLayoutComponent,
        SdgIconListComponent,
        NgForOf,
        MultiLanguageModule,
        PlainTextInputModule,
        DepositTypeComponent,
        DepositDoiComponent,
        MatIcon,
        MatIcon,
        BriefComponent,
        EntityLocalFieldsModule,
        AssetPageComponent,
        UsageMetricsComponent,
        DescriptionAndKeywordsComponent,
        DetailsComponent,
        RelatedContentComponent,
        AssetPageMetadataEssentialsComponent,
        AuthorsEssentialsComponent,
        AssetPageArcviewStandaloneComponent,
        CollectionsEssentialsComponent,
        IncitesHighlightsComponent,
    ],
})
export class AssetPageModule {}
